(function () {
    let dropdownTogglers = document.querySelectorAll('.navbar .dropdown-toggler');
    dropdownTogglers.forEach((toggler) => {
        toggler.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            const previousExpanded = event.currentTarget.classList.contains('expanded');
            const expanded = !previousExpanded;

            let navItem = event.currentTarget.closest('.nav-item');
            let dropdown = navItem.querySelector('.dropdown-wrap');

            removeAllTogglersExpanded();

            if (expanded) {
                event.currentTarget.classList.add('expanded');
                collapseDropdowns(dropdown.id);
                dropdown.classList.add('show');
            } else {
                collapseDropdowns();
            }
        });
    });

    function removeAllTogglersExpanded() {
        let dropdownTogglers = document.querySelectorAll('.navbar .dropdown-toggler');

        dropdownTogglers.forEach((toggler) => {
            toggler.classList.remove('expanded');
        });
    }

    function collapseDropdowns(excludeDrodownId = null) {
        let dropdowns = document.querySelectorAll('.navbar .dropdown-wrap');
        dropdowns.forEach(dropdown => {
            if (dropdown.id == excludeDrodownId) {
                return;
            }
            dropdown.classList.remove('show');
        });
    }

    document.addEventListener("click", function (event) {
        let dropdown = document.querySelector('.navbar .dropdown-wrap.show');

        // Check if the clicked element is NOT inside the dropdown
        if (dropdown && !dropdown.contains(event.target)) {
            removeAllTogglersExpanded();
            collapseDropdowns();
        }
    });
})();